import React from 'react';
import Apresentation from './components/apresentation/apresentation';
import Depoiments from './components/depoiments/depoiments';
import EmpretecForYou from './components/empretec-for-you/empreec-for-you';
import EntrepreneurialCharacteristics from './components/entrepreneurial-characteristics/entrepreneurial-characteristics';
import { Footer } from './components/footer/footer';
import Grow from './components/grow/grow';
import Header from './components/header/header';
import KnowEmpretec from './components/know-empretec/know-empretec';
import NewEmpretecForYou from './components/new-empretec-for-you-faq/new-empretec-for-you';
import Secrets from './components/secrets/secrets';
import Subscription from './components/subscription/subscription';

function Index() {
  return (
    <>
      <Header />
      <Apresentation />
      <EmpretecForYou />
      <KnowEmpretec />
      <EntrepreneurialCharacteristics />
      <Grow />
      <Secrets />
      {/* <FrequentsQuestions /> */}
      <NewEmpretecForYou />
      <Depoiments />
      <Subscription />
      <Footer />
    </>
  );
}

export default Index;
